import React, { useEffect, useState } from "react";
import { UploadSimple, Button } from "@cisco/spaces-dash-lib-styleguide";

function ImageUpload(props) {
  const { showInvalidImageMsg, index, saveImagePath, type, path, fileId } = props;
  const [selectedFile, setSelectedFile] = useState(null);

  const isValidFileExtension = (files) => {
    const extensions = ["JPG", "PNG", "JPEG", "SVG"];
    const ext = files[0]?.name?.toUpperCase().split(".").pop() || files[0].name;
    const exists = extensions.includes(ext);
    return exists;
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    const filePath = path ? `${path}/${selectedFile.name}` : `partner/apps/temp/${selectedFile.name}`;
    formData.append("path", filePath);

    try {
      // const response = await fetch("/api/v1/strapi/uploadToStrapi", {
      const response = await fetch("/api/v1/partnerapps/uploadToS3File", {
        method: "POST",
        body: formData
        // If your API requires authorization or other headers, include them here
        // headers: {
        //   'Authorization': 'Bearer your-token',
        // },
      });

      if (response.ok) {
        const data = await response.json();
        setSelectedFile(null);
        if (index !== undefined && index !== null) {
          saveImagePath(data?.data, type, selectedFile.name, index);
          // saveImagePath(data?.data?.url, type, data?.data?.id, index);
        } else {
          saveImagePath(data?.data, type, selectedFile.name);
          // saveImagePath(data?.data?.url, type, data?.data?.id);
        }
        console.log("File uploaded successfully:", data);
      } else {
        console.error("Upload failed:", response.status, response.statusText);
      }
    } catch (error) {
      console.error("Error during upload:", error);
    }
  };

  const handleFileChange = (event) => {
    if (isValidFileExtension(event.target.files)) {
      setSelectedFile(event.target.files[0]);
    } else {
      showInvalidImageMsg();
    }
  };

  const handleButtonClick = () => {
    document.getElementById(`file-${fileId}`).click();
  };

  useEffect(() => {
    if (selectedFile) {
      handleUpload();
    }
  }, [selectedFile]);

  return (
    <div>
      <input type="file" id={`file-${fileId}`} style={{ display: "none" }} onChange={handleFileChange} />
      <div style={{ margin: 12 }} />
      <Button kind="secondary" onClick={handleButtonClick}>
        <UploadSimple />
        Upload
      </Button>
    </div>
  );
}

export default ImageUpload;
